import { AppBar as MuiAppBar, Toolbar as MuiToolbar } from '@mui/material';
import styled from '@mui/material/styles/styled';

export const AppBar = styled(MuiAppBar)(() => ({
    height: 77,
}));

export const ToolBar = styled(MuiToolbar)(() => ({
    paddingTop: 8,
    paddingBottom: 8,
    justifyContent: 'space-between',
}));
